var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4185 37.0026C29.1781 37.0026 37.0898 29.0908 37.0898 19.3312C37.0898 9.57154 29.1781 1.65979 19.4185 1.65979C9.65882 1.65979 1.74707 9.57154 1.74707 19.3312C1.74707 29.0908 9.65882 37.0026 19.4185 37.0026Z",
    fill: "#CCE7E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.778 11.4355H9.26611V20.4592H13.778V11.4355Z",
    fill: "white",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5853 43.7703H5.50635V27.5954C12.2741 21.7676 15.0715 18.2032 20.8917 12.1874H21.0271C26.8549 18.2032 30.3215 21.7676 35.5853 27.5954V43.7703Z",
    fill: "white",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5457 15.1954L35.5852 30.2348L38.593 27.2269L20.5457 9.17957L2.49829 27.2269L5.50619 30.2348L20.5457 15.1954Z",
    fill: "#83E0CA",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0346 32.4908H10.0188V43.7705H16.0346V32.4908Z",
    fill: "#83E0CA",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.81 32.4908H19.0422V38.5066H25.81V32.4908Z",
    fill: "white",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 43.7705H43.8569",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75444 43.7705H3.25049",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74687 43.7705H0.24292",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8655 43.7705H44.6096",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4048 43.7704C35.7583 33.9948 44.609 32.1148 44.609 24.55C44.6877 23.1892 44.4809 21.827 44.0019 20.5508C43.5229 19.2746 42.7823 18.1128 41.8277 17.1398C40.8731 16.1668 39.7256 15.4041 38.4588 14.9009C37.192 14.3977 35.834 14.1649 34.4719 14.2176C33.1098 14.2702 31.7738 14.6072 30.5497 15.2067C29.3256 15.8063 28.2403 16.6553 27.3637 17.6991C26.4871 18.7429 25.8385 19.9585 25.4595 21.2678C25.0805 22.5772 24.9795 23.9513 25.163 25.302C25.6818 32.3254 33.9911 34.7167 34.337 43.8005L35.4048 43.7704Z",
    fill: "#08C296",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8412 24.55C37.8412 25.1345 37.6679 25.7058 37.3431 26.1918C37.0184 26.6778 36.5569 27.0566 36.0168 27.2803C35.4768 27.504 34.8826 27.5625 34.3094 27.4485C33.7361 27.3344 33.2095 27.053 32.7962 26.6397C32.3829 26.2264 32.1015 25.6998 31.9875 25.1265C31.8734 24.5533 31.9319 23.9591 32.1556 23.4191C32.3793 22.8791 32.7581 22.4175 33.2441 22.0928C33.7301 21.7681 34.3014 21.5947 34.8859 21.5947C35.6697 21.5947 36.4214 21.9061 36.9756 22.4603C37.5298 23.0145 37.8412 23.7662 37.8412 24.55Z",
    fill: "white",
    stroke: "#19213E",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75464 5.41971H9.26648C9.42942 4.81197 9.82323 4.29188 10.364 3.97022C10.9048 3.64857 11.5498 3.55078 12.1616 3.69769C12.4492 3.21013 12.8611 2.80771 13.3553 2.53157C13.8494 2.25543 14.408 2.1155 14.974 2.12607C15.4121 2.09209 15.8524 2.15454 16.2638 2.30903C16.6753 2.46351 17.0479 2.70628 17.3554 3.02025C17.6629 3.33422 17.8979 3.71176 18.0438 4.12631C18.1897 4.54086 18.243 4.98235 18.1999 5.41971H21.2981",
    stroke: "#00857C",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0815 9.93158H43.8572",
    stroke: "#00857C",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5779 9.93158H31.074",
    stroke: "#00857C",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5696 9.93158H28.0657",
    stroke: "#00857C",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25102 5.41974H1.74707",
    stroke: "#00857C",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5618 5.41978H29.4945C29.7193 4.9885 30.0524 4.6231 30.4611 4.35943C30.8698 4.09576 31.34 3.94289 31.8256 3.91583C32.1512 3.91821 32.4731 3.98464 32.7731 4.11134C33.0647 3.31695 33.59 2.62951 34.28 2.13956C34.9699 1.64961 35.7921 1.38014 36.6382 1.36664C38.8941 1.36664 40.7741 3.93839 40.7741 5.44234H46.8651",
    stroke: "#00857C",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0577 5.41974H23.5537",
    stroke: "#00857C",
    strokeWidth: 1.0878,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.c90831530e73e4d3e313eb0a767ef395.svg";
export { ForwardRef as ReactComponent };